<template>
  <div class="contact-box">
    <p class="title">お問合せ</p>
    <p class="txt1">この度は、当サイトをご利用いただきありがとうございます。 <br />
ご注文・ご質問は、お電話または、下記のフォームにて承ります。 <br />
必要事項をご記入の上、送信してください。 <br />
担当より３営業日以内にご連絡いたします。</p>
    <!-- <p class="txt2">
      この度は当サイトをご利用いただきありがとうございます。<br />
      お電話または、下記のフォームからお問合せください。
    </p> -->
    <p class="tel">お電話でのお問い合せ：093-967-6640</p>
    <p class="line"></p>
    <div class="form-box">
      <div
        class="row"
        :class="{
          validate,
          hasLen: params.company
        }"
      >
        <p class="key-box">
          貴社名 <span class="need">必須</span>
        </p>
        <p class="value-box">
          <textarea
            class="textarea" name="" id="" cols="30" rows="10" v-model="params.company"></textarea>
        </p>
      </div>
      <div
        class="row"
        :class="{
          validate,
          hasLen: params.surname && params.name
        }"
      >
        <p class="key-box">
          お名前 <span class="need">必須</span>
        </p>
        <p class="value-box">
          <input class="two" type="text" placeholder="姓" v-model="params.surname" />
          <input class="two" type="text" placeholder="名" v-model="params.name" />
        </p>
      </div>
      <div
        class="row"
        :class="{
          validate,
          hasLen: params.email1 || params.email2
        }"
      >
        <p class="key-box">
          メールアドレス <span class="need">必須</span>
        </p>
        <p class="value-box">
          <input class="one" type="text" placeholder="" v-model="params.email1" />
          <input class="one" type="text" placeholder="" v-model="params.email2" />
        </p>
      </div>
      <div
        class="row"
        :class="{
          validate,
          hasLen: params.contact1 && params.contact2 && params.contact3
        }"
      >
        <p class="key-box">
          ご連絡先 <span class="need">必須</span>
        </p>
        <p class="value-box row-three">
          <input class="three" type="text" v-model="params.contact1" />
          <span class="mark"></span>
          <input class="three" type="text" v-model="params.contact2" />
          <span class="mark"></span>
          <input class="three" type="text" v-model="params.contact3" />
        </p>
      </div>
      <div class="row">
        <p class="key-box">
          ご住所 <span class="any">任意</span>
        </p>
        <div class="value-box">
          <p class="item">
            <span class="key">郵便番号</span>
            <span class="value">
              <input class="code" type="text" v-model="params.zipcode" />
            </span>
          </p>
          <p class="item">
            <span class="key">都道府県</span>
            <span class="value">
              <el-select
                filterable
                v-model="params.dudaofu"
              >
                <el-option
                  v-for="item in provinceData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </span>
          </p>
          <p class="item">
            <span class="key">市区町村</span>
            <span class="value">
              <input class="input" type="text" v-model="params.area" />
            </span>
          </p>
          <p class="item">
            <span class="key">番地</span>
            <span class="value">
              <input class="input" type="text" v-model="params.plate" />
            </span>
          </p>
          <p class="item">
            <span class="key">マンション・ビル名</span>
            <span class="value">
              <input class="input" type="text" v-model="params.apartment" />
            </span>
          </p>
        </div>
      </div>
      <div
        class="row"
        :class="{
          validate,
          hasLen: params.remark
        }"
      >
        <p class="key-box">
          お見積依頼・お問合せ内容 <span class="need">必須</span>
        </p>
        <p class="value-box content">
          <span class="name">※メーカー名、商品名、数量、希望納期など</span>
          <textarea class="textarea" name="" cols="30" rows="10" v-model="params.remark"></textarea>
        </p>
      </div>
      <div class="row">
        <p class="btn" @click="submit">送信する</p>
      </div>
    </div>
  </div>
</template>

<script>
import { add } from '../../api/home'

export default {
  name: 'index',
  data () {
    return {
      validate: false,
      provinceData: [
        {
          value: '北海道',
          label: '北海道'
        },
        {
          value: '青森県',
          label: '青森県'
        },
        {
          value: '岩手県',
          label: '岩手県'
        },
        {
          value: '宮城県',
          label: '宮城県'
        },
        {
          value: '秋田県',
          label: '秋田県'
        },
        {
          value: '山形県',
          label: '山形県'
        },
        {
          value: '福島県',
          label: '福島県'
        },
        {
          value: '茨城県',
          label: '茨城県'
        },
        {
          value: '栃木県',
          label: '栃木県'
        },
        {
          value: '群馬県',
          label: '群馬県'
        },
        {
          value: '埼玉県',
          label: '埼玉県'
        },
        {
          value: '千葉県',
          label: '千葉県'
        },
        {
          value: '東京都',
          label: '東京都'
        },
        {
          value: '神奈川県',
          label: '神奈川県'
        },
        {
          value: '新潟県',
          label: '新潟県'
        },
        {
          value: '富山県',
          label: '富山県'
        },
        {
          value: '石川県',
          label: '石川県'
        },
        {
          value: '福井県',
          label: '福井県'
        },
        {
          value: '山梨県',
          label: '山梨県'
        },
        {
          value: '長野県',
          label: '長野県'
        },
        {
          value: '岐阜県',
          label: '岐阜県'
        },
        {
          value: '静岡県',
          label: '静岡県'
        },
        {
          value: '愛知県',
          label: '愛知県'
        },
        {
          value: '三重県',
          label: '三重県'
        },
        {
          value: '滋賀県',
          label: '滋賀県'
        },
        {
          value: '京都府',
          label: '京都府'
        },
        {
          value: '大阪府',
          label: '大阪府'
        },
        {
          value: '兵庫県',
          label: '兵庫県'
        },
        {
          value: '奈良県',
          label: '奈良県'
        },
        {
          value: '和歌山県',
          label: '和歌山県'
        },
        {
          value: '鳥取県',
          label: '鳥取県'
        },
        {
          value: '島根県',
          label: '島根県'
        },
        {
          value: '岡山県',
          label: '岡山県'
        },
        {
          value: '広島県',
          label: '広島県'
        },
        {
          value: '山口県',
          label: '山口県'
        },
        {
          value: '徳島県',
          label: '徳島県'
        },
        {
          value: '香川県',
          label: '香川県'
        },
        {
          value: '愛媛県',
          label: '愛媛県'
        },
        {
          value: '高知県',
          label: '高知県'
        },
        {
          value: '福岡県',
          label: '福岡県'
        },
        {
          value: '佐賀県',
          label: '佐賀県'
        },
        {
          value: '長崎県',
          label: '長崎県'
        },
        {
          value: '熊本県',
          label: '熊本県'
        },
        {
          value: '大分県',
          label: '大分県'
        },
        {
          value: '宮崎県',
          label: '宮崎県'
        },
        {
          value: '鹿児島県',
          label: '鹿児島県'
        },
        {
          value: '沖縄県',
          label: '沖縄県'
        }
      ],
      params: {
        company: '', // 貴社名
        surname: '', // 姓
        name: '', // 名
        email1: '', // email
        email12: '', // email
        contact1: '', // 联系方式，多个逗号分隔
        contact2: '', // 联系方式，多个逗号分隔
        contact3: '', // 联系方式，多个逗号分隔
        zipcode: '', // 邮便番号
        dudaofu: '', // 都道府县
        area: '', // 市区
        plate: '', // 门牌号
        apartment: '', // 公寓大楼名称
        remark: '' // 洽谈内容
      }
    }
  },
  methods: {
    async submit () {
      this.validate = true
      const {
        company, // 貴社名
        surname, // 姓
        name, // 名
        email1, // email
        email2, // email
        contact1, // 联系方式，多个逗号分隔
        contact2, // 联系方式，多个逗号分隔
        contact3, // 联系方式，多个逗号分隔
        zipcode, // 邮便番号
        dudaofu, // 都道府县
        area, // 市区
        plate, // 门牌号
        apartment, // 公寓大楼名称
        remark // 洽谈内容
      } = this.params
      if (!company ||
        !surname ||
        !name ||
        !this.calcMulTxt(email1, email2) ||
        !this.calcMulTxt(contact1, contact2, contact3) ||
        !remark
      ) return
      const res = await add({
        company, // 貴社名
        surname, // 姓
        name, // 名
        email: this.calcMulTxt(email1, email2), // email
        contact: this.calcMulTxt(contact1, contact2, contact3), // 联系方式，多个逗号分隔
        zipcode, // 邮便番号
        dudaofu, // 都道府县
        area, // 市区
        plate, // 门牌号
        apartment, // 公寓大楼名称
        remark // 洽谈内容
      })
      this.$message({
        message: res.data.msg,
        type: !res.data.success ? 'error' : 'success'
      })
      if (res.data.success) {
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      }
      console.log('submit==', res)
    },
    calcMulTxt (...arr) {
      let arr2 = []
      arr2 = arr.filter(v => v)
      return arr2.join(',')
    }
  }
}
</script>

<style lang="less" scoped>
.contact-box{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 173px;

  .title{
    font-family: HarmonyOS_Sans_SC_Bold;
    font-weight: 400;
    font-size: 72px;
    color: #E09B4D;
    line-height: 123px;

    margin-left: 265px;
    margin-top: 10px;
  }

  .txt1{
    font-family: 04KanjyukuGothic;
    font-weight: 400;
    font-size: 28px;
    color: #333333;
    line-height: 42px;
    margin-left: 265px;
  }

  .txt2{
    font-family: 04KanjyukuGothic;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
    line-height: 36px;
    margin-left: 265px;
    margin-top: 28px;
  }

  .tel{
    font-family: Alibaba;
    font-weight: normal;
    font-size: 30px;
    color: #374475;
    line-height: 42px;
    margin-left: 265px;
    margin-top: 32px;
  }
  .line{
    width: 1340px;
    height: 1px;
    background-color: #D5D2D2;
    margin-left: 265px;
    margin-top: 40px;
    margin-bottom: 32px;
  }
  .form-box{
    display: flex;
    flex-direction: column;

    .row{
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      margin-top: 32px;

      &.validate{
        textarea,input{
          border-color: red !important;
        }

        &.hasLen{
          textarea,input{
            border-color: #ccc !important;
          }
        }
      }

      .key-box{
        flex-shrink: 0;
        margin-left: 163px;
        width: 351px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 24px;
        color: #374475;
        line-height: 30px;
        margin-top: 10px;

        .need{
          width: 57px;
          height: 30px;
          background: #E09B4D;
          border-radius: 10px;
          text-align: center;

          font-family: 04KanjyukuGothic;
          font-weight: 400;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 30px;
          margin-left: 8px;
        }

        .any{
          font-family: 04KanjyukuGothic;
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          line-height: 30px;
          margin-left: 25px;
        }
      }

      .value-box{
        margin-left: 18px;

        &.row-three{
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        &.content{
          display: flex;
          flex-direction: column;

          .name{
            font-family: 04KanjyukuGothic;
            font-weight: 400;
            font-size: 20px;
            color: #666666;
            line-height: 30px;
            margin-left: 20px;
            margin-bottom: 14px;
          }

          .textarea{
            height: 401px;
          }
        }

        .textarea{
          width: 940px;
          height: 82px;
          background: #E6F0F7;
          border-radius: 10px;
          border: 2px solid #374475;
          padding: 10px;
          resize: none;
          font-size: 20px;
        }

        .two{
          width: 444px;
          height: 56px;
          background: #E6F0F7;
          border-radius: 10px;
          border: 2px solid #374475;
          padding: 0px 10px;
          font-size: 20px;

          &:nth-child(2){
            margin-left: 27px;
          }
        }

        .one{
          width: 940px;
          height: 56px;
          background: #E6F0F7;
          border-radius: 10px;
          border: 2px solid #374475;
          font-size: 20px;
          padding: 0px 10px;

          &:nth-child(2){
            margin-top: 11px;
          }
        }
        .three{
          width: 274px;
          height: 56px;
          background: #E6F0F7;
          border-radius: 10px;
          border: 2px solid #374475;
          font-size: 20px;
          padding: 0px 10px;
        }

        .mark{
          display: inline-block;
          width: 17px;
          height: 2px;
          background: #374475;
          margin: 0px 8px;
        }

        .item{
          display: flex;
          flex-direction: column;

          .key{
            font-family: 04KanjyukuGothic;
            font-weight: 400;
            font-size: 20px;
            color: #666666;
            line-height: 30px;
            margin-left: 16px;
            margin-top: 10px;
            margin-bottom: 10px;
          }

          .value{
            font-size: 20px;
            margin-bottom: 16px;
            .code{
              width: 190px;
              height: 56px;
              background: #FFFFFF;
              border-radius: 10px;
              border: 1px solid #CCCCCC;
              font-size: 20px;
              padding: 0px 10px;
            }

            .select{
              width: 274px;
              height: 56px;
              background: #FFFFFF;
              border-radius: 10px;
              border: 1px solid #CCCCCC;
              font-size: 20px;
              padding: 0px 10px;
            }

            .input{
              width: 940px;
              height: 56px;
              background: #FFFFFF;
              border-radius: 10px;
              border: 1px solid #CCCCCC;
              padding: 0px 10px;
              font-size: 20px;
            }
          }
        }
      }
    }
  }

  .btn{
    width: 280px;
    height: 60px;
    background: #374475;
    border-radius: 40px;
    font-family: 04KanjyukuGothic;
    font-weight: 400;
    font-size: 30px;
    color: #F6F6F6;
    line-height: 60px;
    text-align: center;
    margin-left: 528px;
    cursor: pointer;
    opacity: 1;
    user-select: none;

    &:active{
      opacity: .8;
    }
  }
}
</style>
